<template>
  <div>
    <afstereo-dashboard
      :selectedDate="selectedDate"
      :selectedPeriod="selectedPeriod"
      :selectedStation="selectedStation"
      :chartsData="chartsData"
      :stations="stations"
      :pluginEnabled="isPluginEnabled('app.dashboard.afstereo')"
      @previous="handlePrevious($event)"
      @next="handleNext($event)"
      @changePeriod="handleChangePeriod($event)"
      @changeStation="handleChangeStation($event)">
    </afstereo-dashboard>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AfstereoDashboard from '@/components/analytics/AfstereoDashboard';

import * as afstereoTypes from '@/store/modules/afstereo/mutation-types';

export default {
  name: 'AfstereoContainer',
  components: {
    AfstereoDashboard,
  },
  computed: {
    ...mapState('afstereo', [
      'selectedDate',
      'selectedPeriod',
      'selectedStation',
      'chartsData',
      'stations',
    ]),
    ...mapState('user', ['me']),
    ...mapState('plugin', ['plugins']),
  },
  mounted() {
    this.$store.dispatch('afstereo/getCharts');
    this.$store.dispatch('afstereo/getStations');
  },
  methods: {
    handlePrevious(event) {
      this.$store.commit(`afstereo/${afstereoTypes.SUBTRACT_AFSTEREO_DATE}`, {
        period: event.unit,
        amount: 1,
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    handleNext(event) {
      this.$store.commit(`afstereo/${afstereoTypes.ADD_AFSTEREO_DATE}`, {
        period: event.unit,
        amount: 1,
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    handleChangePeriod(event) {
      if (this.selectedPeriod === event.unit) return;

      this.$store.commit(`afstereo/${afstereoTypes.SET_AFSTEREO_PERIOD}`, { period: event.unit });
      this.$store.commit(`afstereo/${afstereoTypes.RESET_AFSTEREO_STATIONS_AREA}`);
      this.$store.dispatch('afstereo/getCharts');
    },
    handleChangeStation(event) {
      this.$store.commit(`afstereo/${afstereoTypes.SET_AFSTEREO_STATION}`, {
        station: event.station,
      });
      this.$store.dispatch('afstereo/getCharts');
    },
    isPluginEnabled(pluginPermissions) {
      const permissions = this.plugins.filter(plugin => plugin.plugin_route === pluginPermissions)
        .length;
      return permissions >= 1;
    },
  },
};
</script>




// WEBPACK FOOTER //
// AfstereoContainer.vue?267dbab6